module.exports = __webpack_public_path__ + "img/21.90227bfb.png";